import { render, staticRenderFns } from "./promoterData.vue?vue&type=template&id=5ae1b8f0"
import script from "./promoterData.vue?vue&type=script&lang=js"
export * from "./promoterData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports